module.exports = __webpack_public_path__ + "img/SIGLE-MANAGEO.50d618a8.svg";